module.exports = __webpack_public_path__ + "static/pic20-574b19b1ee2704b2bb9b64e9b4e69ce7.png";